<script lang="ts">
    export let text: string = 'Click me';
    export let disabled: boolean = false;
    export let showIcon: boolean = true;
</script>

<button class="btn-main" class:showIcon on:click {disabled}>
    {text}
    {#if showIcon}
        <icon></icon>
    {/if}
</button>

<style>
    .btn-main {
        background-color: #f7b936;
        color: #000;
        padding: 5px 20px;
        border-radius: 5px;
        border: none;
        cursor: pointer;
        font-size: 16px;
        font-weight: 400;
        min-width: 130px;
        min-height: 32px;
        position: relative;
    }
    .showIcon {
        padding-right: 40px;
    }
    .btn-main icon {
        background-image: url('Icons/svg/navigate_next_FILL0_wght400_GRAD0_opsz24.svg');
        background-repeat: no-repeat;
        background-position: 0px center;
        background-size: 24px;
        position: absolute;
        width: 20px;
        height: 20px;
        padding: 0 10px;
        margin: 0 10px;
        opacity: 0.6;
    }
    /*.btn-main:hover {*/
    /*    opacity: 0.8;*/
    /*    transition: 0.2s;*/
    /*}*/
    .btn-main[disabled] {
        background-color: var(--automapa-grey-dark);
        cursor: not-allowed;
    }
</style>
